/**
 * HLLBNT Branding - Centralised config
 *
 * Single source of truth for all Hellbent branding references
 * across the site (footer link, preview gate, etc.).
 */

export const hllbnt = {
  name: 'HLLBNT',
  domain: 'hllbnt.au',
  url: 'https://hllbnt.au',
  logo: '/hllbnt-gate/logo.svg',
  colors: {
    pink: '#FF00AF',
    magenta: '#ff00ff',
    magentaHover: '#d600d6',
  },
  /** Hex signature: "getbnt" in ASCII */
  hexSignature: '67 65 74 62 6E 74',
  /** UTM-tagged URL for client footer attribution */
  footerUrl: (clientSlug: string) =>
    `https://hllbnt.au?utm_source=${clientSlug}&utm_medium=referral&utm_campaign=client_footer&utm_content=built_by`,
  /** UTM-tagged URL for preview gate branding */
  gateUrl: (clientSlug: string) =>
    `https://hllbnt.au?utm_source=${clientSlug}&utm_medium=referral&utm_campaign=preview_gate&utm_content=logo`,
  /** UTM-tagged URL for the footer of an automated notification */
  emailUrl: (clientSlug: string) =>
    `https://hllbnt.au?utm_source=${clientSlug}&utm_medium=referral&utm_campaign=notification_footer&utm_content=built_by`,
} as const
